import type { AssetPreviewDto } from '@terra/shared-contracts-assets';
import type { OpenMainContentTabInput } from '../../../store/layoutStore';

export const getEndpointTabInput = ({
  id,
  method,
  path,
}: {
  id: string;
  method: string;
  path: string;
}): OpenMainContentTabInput => ({
  id: `endpoint-${id}`,
  title: `${method} ${path}`,
  type: 'endpoint',
  data: { endpointId: id },
});

export const getWebpageTabInput = ({
  id,
  url,
}: {
  id: string;
  url: string;
}): OpenMainContentTabInput => ({
  id: `webpage-${id}`,
  title: url,
  type: 'webpage',
  data: { id },
});

export const getFindingTabInput = ({
  id,
  title,
}: {
  id: string;
  title: string;
}): OpenMainContentTabInput => ({
  id: `finding-${id}`,
  title,
  type: 'finding',
  data: { findingId: id, mode: 'view' },
});

export const getSignalTabInput = ({
  id,
  title,
}: {
  id: string;
  title: string;
}): OpenMainContentTabInput => ({
  id: `signal-${id}`,
  title,
  type: 'signal',
  data: { signalId: id },
});

export const getAssetTabInput = ({
  asset,
  applicationId,
}: {
  asset: AssetPreviewDto;
  applicationId: string;
}): OpenMainContentTabInput => {
  switch (asset.assetType) {
    case 'endpoint':
      return getEndpointTabInput({
        id: asset.id,
        method: asset.request.method || 'GET',
        path: asset.path || asset.url,
      });
    case 'webpage':
      return getWebpageTabInput({ id: asset.id, url: asset.url });
    case 'unverifiedEndpoint':
      return {
        id: `unverified-endpoint-${asset.id}`,
        title: `${asset.request.method} ${asset.path || asset.url}`,
        type: 'unverified-endpoint',
        data: { candidateId: asset.id, applicationId },
      };
  }
};
